import {
  Body,
  Col,
  Flex,
  Row,
  SubTitle,
  styled,
  useTheme,
} from '@teko/ds-desktop';
import { Checkbox } from '@teko/ui';
import { t } from 'i18n';

interface ILocationPickerItemProps {
  address: string;
  name: string;
  onClick: () => void;
  active: boolean;
  isDefault: boolean;
  telephone: string;
}

export const LocationPickerItem = (props: ILocationPickerItemProps) => {
  const { address, onClick, active, name, isDefault, telephone } = props;

  const theme = useTheme();

  return (
    <Wrapper onClick={onClick} align="top" justify="start">
      <StyledCheckBox circle checked={active} />
      <Col marginLeft="s12" width="90%">
        <Row justify="start">
          <SubTitle
            style={{
              fontSize: '13px',
              color: theme.colors.black,
              fontWeight: 500,
            }}
          >
            {name}
          </SubTitle>
          {isDefault && (
            <Flex
              backgroundColor="#F0F5FF"
              paddingLeft="s8"
              paddingRight="s8"
              border="s4"
              justify="center"
              align="center"
              marginLeft="s4"
            >
              <Body
                style={{
                  fontSize: '12px',
                  color: theme.colors.primary,
                  fontWeight: 400,
                }}
              >
                {t('Mặc định')}
              </Body>
            </Flex>
          )}
        </Row>
        <SubTitle
          style={{
            fontSize: '13px',
            color: theme.colors.textSecondary,
          }}
        >
          {telephone}
        </SubTitle>
        <SubTitle
          style={{
            fontSize: '13px',
            color: theme.colors.textSecondary,
          }}
        >
          {address}
        </SubTitle>
      </Col>
    </Wrapper>
  );
};

const Wrapper = styled(Row)`
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  cursor: pointer;
`;

const StyledCheckBox = styled(Checkbox)(
  ({ theme }) => `
  width: 16px;
  height: 16px;
  border: 1px solid ${theme.colors.primary};
  margin-top: 5px;
`,
);
